import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './main-request.component.html',
})
export class MainRequestComponent {
}
